import { render, staticRenderFns } from "./editGoods.vue?vue&type=template&id=62e0a3bb&scoped=true&"
import script from "./editGoods.vue?vue&type=script&lang=js&"
export * from "./editGoods.vue?vue&type=script&lang=js&"
import style0 from "./editGoods.vue?vue&type=style&index=0&id=62e0a3bb&prod&lang=scss&scoped=true&"
import style1 from "./editGoods.vue?vue&type=style&index=1&id=62e0a3bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e0a3bb",
  null
  
)

export default component.exports